import { getMessageMediaApiUrlMiddleware } from "../../../config/config";
import { baseFetch } from "./baseFetch";

const baseUrl = `${getMessageMediaApiUrlMiddleware()}/iam/v1/users`;
export const fetchUserDetails = async (token: string, username: string) =>
  baseFetch(`${baseUrl}/${encodeURIComponent(username)}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
